module.exports = __webpack_public_path__ + "media/fonts/Unica77LLTT-Bold-adae91a6b9102c07da2f55fd74a01b5e.woff2";